import type { Draft, OpenEndedQ } from '../types';
import styles from '../QuizView.module.css';

export type Assessment = {
  score?: string;
  feedback?: string;
  suggestions?: string;
  missing_concepts?: string[];
};

type Props = {
  question: OpenEndedQ;
  draft: Extract<Draft, { format: 'open_ended' }>;
  onChange: (d: Extract<Draft, { format: 'open_ended' }>) => void;
  disabled: boolean;
  showFeedback: boolean;
  assessment?: Assessment;
  modelAnswer?: string;
};

const SCORE_LABEL: Record<string, string> = {
  excellent: 'Excelente',
  good: 'Bien',
  needs_improvement: 'A mejorar'
};

export function OpenEnded({
  draft,
  onChange,
  disabled,
  showFeedback,
  assessment,
  modelAnswer
}: Props) {
  const score = assessment?.score;
  return (
    <div className={styles.openEnded}>
      <textarea
        className={styles.textarea}
        value={draft.text}
        placeholder="Escribe tu respuesta…"
        disabled={disabled}
        onChange={(e) => onChange({ format: 'open_ended', text: e.target.value })}
        rows={5}
      />
      <div className={styles.charCount}>{draft.text.trim().length} caracteres</div>

      {showFeedback && score && (
        <div className={styles.scoreRow}>
          <span className={styles.scoreBadge} data-score={score}>
            {SCORE_LABEL[score] ?? score}
          </span>
        </div>
      )}

      {showFeedback && assessment?.feedback && (
        <div className={styles.assessmentBlock}>
          <span className={styles.assessmentLabel}>Comentario</span>
          <p>{assessment.feedback}</p>
        </div>
      )}

      {showFeedback && assessment?.suggestions && (
        <div className={styles.assessmentBlock}>
          <span className={styles.assessmentLabel}>Cómo mejorar</span>
          <p>{assessment.suggestions}</p>
        </div>
      )}

      {showFeedback && Array.isArray(assessment?.missing_concepts) && assessment!.missing_concepts!.length > 0 && (
        <div className={styles.assessmentBlock}>
          <span className={styles.assessmentLabel}>Conceptos que faltan</span>
          <ul className={styles.missingList}>
            {assessment!.missing_concepts!.map((c, i) => (
              <li key={i}>{c}</li>
            ))}
          </ul>
        </div>
      )}

      {showFeedback && modelAnswer && (
        <details className={styles.modelBox}>
          <summary>Ver respuesta modelo</summary>
          <p>{modelAnswer}</p>
        </details>
      )}
    </div>
  );
}
